import React from "react";
import { FaAngular, FaReact, FaJs, FaNodeJs } from "react-icons/fa";
import {
  SiTypescript,
  SiRedux,
  SiExpress,
  SiNestjs,
  SiMongodb,
  SiPostgresql,
  SiPrisma,
  SiTypeorm,
} from "react-icons/si";
import Chip from "@mui/material/Chip";
import "../assets/styles/Expertise.scss";

const frontendLabels = [
  "TypeScript",
  "JavaScript",
  "React",
  "Redux Toolkit",
  "Angular",
  "RxJS",
];

const backendLabels = ["NodeJS", "ExpressJS", "NestJS"];

const databaseLabels = ["SQL", "PostgreSQL", "Mongoose", "Mongoose", "TypeORM"];

function Expertise({ mode }) {
  return (
    <div className="container" id="expertise">
      <div className="skills-container">
        <h1>Expertise</h1>
        <div className="skills-grid">
          {/* Frontend */}
          <div className="skill">
            <div className="icons-row">
              <SiTypescript size={35} color="#3178c6" />
              <FaJs size={35} color="#f7df1e" />
              <FaReact size={35} color="#61dafb" />
              <SiRedux size={35} color="#764abc" />
              <FaAngular size={35} color="#dd0031" />
            </div>
            <h3>Frontend Development</h3>
            <p>
              I specialize in building dynamic, responsive, and user-friendly
              interfaces using modern JavaScript frameworks. My experience
              includes extensive use of Angular, React, Redux Toolkit, and RxJS,
              along with deep proficiency in JavaScript and TypeScript to create
              efficient frontend architectures.
            </p>
            <div className="flex-chips">
              <span className="chip-title">Tech stack:</span>
              {frontendLabels.map((label, index) => (
                <Chip key={index} className="chip" label={label} />
              ))}
            </div>
          </div>

          {/* Backend */}
          <div className="skill">
            <div className="icons-row">
              <FaNodeJs size={35} color="#68a063" />
              {mode === "dark" ? (
                <SiExpress size={35} color="#FFFFFF" />
              ) : (
                <SiExpress size={35} color="#000000" />
              )}
              <SiNestjs size={35} color="#e0234e" />
            </div>
            <h3>Backend Development</h3>
            <p>
              I have hands-on experience designing and building scalable backend
              systems using Node.js, Express, and NestJS. My focus is on
              crafting clean, modular, and secure APIs that integrate seamlessly
              with frontend applications while following best practices in
              software design and architecture.
            </p>
            <div className="flex-chips">
              <span className="chip-title">Tech stack:</span>
              {backendLabels.map((label, index) => (
                <Chip key={index} className="chip" label={label} />
              ))}
            </div>
          </div>

          {/* Database */}
          <div className="skill">
            <div className="icons-row">
              <SiPostgresql size={35} color="#336791" />
              <SiMongodb size={35} color="#47a248" />
              {mode === "dark" ? (
                <SiTypeorm size={35} color="#ffffff" />
              ) : (
                <SiTypeorm size={35} color="#000000" />
              )}
            </div>
            <h3>Database Management</h3>
            <p>
              I am skilled in working with both relational and non-relational
              databases, with a strong emphasis on PostgreSQL and MongoDB. I
              utilize tools like Prisma and Mongoose to manage schema
              definitions, migrations, and database interactions in a clean and
              efficient manner.
            </p>
            <div className="flex-chips">
              <span className="chip-title">Tech stack:</span>
              {databaseLabels.map((label, index) => (
                <Chip key={index} className="chip" label={label} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Expertise;
